export default "__VITE_ASSET__f08b3a3a__"